module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/nudge/tag-nudge-6a7dc736c14a95b063d4c440bbe08b98.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/nudge/tag-nudge.svg
// module id = +el/
// module chunks = 24